export const intersperse = <T>(array: T[], seperator: (index: number) => T) =>
    array.length === 0
        ? []
        : array
              .slice(1)
              .reduce(
                  (accumulator: T[], currentElement: T, currentIndex: number) => [
                      ...accumulator,
                      seperator(currentIndex + 1),
                      currentElement
                  ],
                  [array[0]]
              );



// WEBPACK FOOTER //
// ./src/utilities/intersperse.ts